const fetched = require('./fetched');
const fetchFailed = require('./fetchFailed');
const fetchRequested = require('./fetchRequested');
const fetchSucceeded = require('./fetchSucceeded');
const fetchSubCategories =  require('./fetchSubCategories');
const fetchMinimumDetails =  require('./fetchMinimumDetails');

module.exports = {
    fetched,
    fetchFailed,
    fetchRequested,
    fetchSucceeded,
    fetchSubCategories,
    fetchMinimumDetails
};
